import React from "react";
import { useDispatch /*, useSelector*/ } from "react-redux";

// Material-UI Core
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

// Material-UI Lab
import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";

// Material-UI Icon
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import FolderOpenTwoToneIcon from "@material-ui/icons/FolderOpenTwoTone";

// Custom Style
import {
  blueColor,
  goldColor,
  greenColor,
  grayColor,
} from "../../styles/jss/cmsMainStyle";
import styles from "../../styles/jss/components/fileManager/fileManagerExplorerStyle";

const useStyles = makeStyles(styles);

const FileManagerExplorer = (props) => {
  const {
    folderData,
    setFolderRight,
    expanded,
    selected,
    handleTreeViewToggle,
    handleTreeViewSelect,
    loading,
  } = props;
  const dispatch = useDispatch();
  let navPath = [];

  const getNavPath = (name, level) => {
    if (level === 1) {
      navPath = [];
      navPath = [...navPath, name];
    } else {
      navPath.splice(level - 1, navPath.length - (level - 1));
      navPath = [...navPath, name];
    }

    return navPath;
  };

  const handleFolderClick = (navPath, treeItemData) => (event) => {
    setFolderRight(treeItemData.rights);

    if (navPath !== null) {
      const path = navPath.split(",");

      dispatch({
        type: "FOLDER_NAV",
        data: path,
      });
    }

    dispatch({
      type: "FOLDER_SELECT",
      data: treeItemData,
    });
  };

  const getTreeItemsFromData = (treeItems) => {
    const fontColor = blueColor[12];
    const bgColor = blueColor[0];

    if (treeItems !== null) {
      return treeItems.map((treeItemData) => {
        const folderColor =
          treeItemData.folder_type === "SYSTEM"
            ? goldColor
            : treeItemData.folder_type === "CUSTOM"
            ? blueColor[3]
            : treeItemData.folder_type === "PRIVATE"
            ? greenColor[4]
            : grayColor[4];
        let children = undefined;

        if (treeItemData.childs && treeItemData.childs.length > 0) {
          children = getTreeItemsFromData(treeItemData.childs);
        }

        return (
          <FileTreeItem
            key={treeItemData.folder_seq}
            nodeId={treeItemData.folder_seq.toString()}
            labelIcon={FolderOpenTwoToneIcon}
            labelNode={treeItemData.folder_seq}
            labelText={treeItemData.name}
            labelLevel={treeItemData.level}
            labelInfo={treeItemData.property_count}
            children={children}
            treeItemData={treeItemData}
            color={fontColor}
            bgColor={bgColor}
            fColor={folderColor}
          />
        );
      });
    }
  };

  const FileTreeItem = (props) => {
    const classes = useStyles();
    const {
      labelNode,
      labelText,
      labelLevel,
      labelIcon: LabelIcon,
      labelInfo,
      treeItemData,
      color,
      bgColor,
      fColor,
      ...other
    } = props;
    const navPath = getNavPath(labelText, labelLevel);

    return (
      <TreeItem
        label={
          <div className={classes.labelRoot}>
            <LabelIcon color="inherit" className={classes.labelIcon} />

            <Typography variant="body2" className={classes.labelText}>
              {labelText}
            </Typography>

            <Typography variant="caption" color="inherit">
              {labelInfo !== -1 ? labelInfo : ""}
            </Typography>
          </div>
        }
        onClick={handleFolderClick(navPath.toString(), treeItemData)}
        style={{
          "--folder-color": fColor,
          "--tree-view-color": color,
          "--tree-view-bg-color": bgColor,
        }}
        classes={{
          root: classes.root,
          content: classes.content,
          expanded: classes.expanded,
          selected: classes.selected,
          group: classes.group,
          label: classes.label,
        }}
        {...other}
      />
    );
  };

  const DataTreeView = (props) => {
    const {
      treeItems,
      expanded,
      selected,
      handleTreeViewToggle,
      handleTreeViewSelect,
    } = props;

    return (
      <TreeView
        defaultCollapseIcon={<ArrowDropDownIcon />}
        defaultExpandIcon={<ArrowRightIcon />}
        defaultEndIcon={<div style={{ width: 25 }} />}
        expanded={expanded}
        selected={selected}
        onNodeToggle={handleTreeViewToggle}
        onNodeSelect={handleTreeViewSelect}
      >
        {getTreeItemsFromData(treeItems)}
      </TreeView>
    );
  };

  return (
    <div>
      {loading}
      <DataTreeView
        treeItems={folderData}
        expanded={expanded}
        selected={selected}
        handleTreeViewToggle={handleTreeViewToggle}
        handleTreeViewSelect={handleTreeViewSelect}
      />
    </div>
  );
};

export default FileManagerExplorer;
